import { render, staticRenderFns } from "./BeneficiaryResults.vue?vue&type=template&id=5f58fad2&scoped=true"
import script from "./BeneficiaryResults.vue?vue&type=script&lang=js"
export * from "./BeneficiaryResults.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryResults.vue?vue&type=style&index=0&id=5f58fad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58fad2",
  null
  
)

export default component.exports